import {Close} from '@mui/icons-material'
import {
  Alert,
  Box,
  IconButton,
  Modal,
  Stack,
  Card,
  CardHeader,
  Grid,
} from '@mui/material'
import React, {useState, useEffect} from 'react'
import WbOutlineButton from '../../common/WbOutlineButton'
import WbButton from '../../common/WbButton'
import {Chip, TextField} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import {surveysApi, surveyTagsApi} from '../../../services'
import WbAlert from '../../common/WbAlert'
import paths from '../../../routes/paths'
import useCustomerData from '../../../hooks/useCustomerData'

export default function TagBlocker({show, onClose, survey, width}) {
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])

  const customer = useCustomerData()

  useEffect(() => {
    surveyTagsApi.get(customer.id, customer.customerType).then(response => {
      setTags([
        ...response?.map(t => {
          return {
            tag: t.tag,
          }
        }),
      ])
    })
  }, [])
  const onSave = () => {
    surveysApi
      .put({
        ...survey,
        name: survey?.name,
        surveysTags: selectedTags?.map(t => t.tag),
      })
      .then(response => {
        window.location.href = paths.questionPanel.replace(
          ':token',
          encodeURIComponent(response.token)
        )
        WbAlert({
          message: 'Survey updated successfully',
          type: 'success',
        })
        onClose(false)
      })
  }

  return (
    <Modal open={show}>
      <Box
        sx={{
          backgroundColor: 'white',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: width ? width : '50%',
          border: '0px',
        }}
      >
        <Card sx={{padding: '24px', borderRadius: '0'}}>
          <CardHeader
            title="Survey Tags"
            sx={{padding: '0px'}}
            action={
              <IconButton aria-label="close" onClick={onClose}>
                <Close></Close>
              </IconButton>
            }
          />
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} mt={3}>
              <Alert severity="info">
                Survey tags help you and our AI find and re-use surveys and
                questions in the future. Select from the existing tags or create
                a new one(s) below. You can choose up to three tags.
              </Alert>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
              <label>Tags</label>
              <Autocomplete
                sx={{marginTop: '10px'}}
                freeSolo
                multiple
                value={selectedTags}
                className="survey-name-txt"
                options={[
                  ...tags?.sort((a, b) => a.tag.localeCompare(b.tag)),
                ].map(t => t)}
                getOptionLabel={option => option.tag}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    return (
                      <Chip
                        label={option.tag}
                        {...getTagProps({index})}
                        onDelete={s =>
                          setSelectedTags(
                            selectedTags.filter((t, i) => i !== index)
                          )
                        }
                      />
                    )
                  })
                }
                onChange={(event, newValue) => {
                  if (selectedTags.length >= 3) {
                    WbAlert({
                      message: 'You can only select up to 3 tags',
                      type: 'error',
                    })
                    return
                  }
                  let contained = false
                  if (
                    selectedTags.findIndex(
                      y => y.tag === newValue[newValue.length - 1].tag
                    ) !== -1
                  ) {
                    contained = true
                  }
                  if (contained) {
                    WbAlert({
                      message: 'You can only select unique tags',
                      type: 'error',
                    })
                    return
                  }

                  if (newValue.length > 0) {
                    if (newValue[newValue.length - 1].inputValue) {
                      surveyTagsApi.post({
                        tag: newValue[newValue.length - 1].inputValue,
                        schoolId: survey.schoolId,
                        matId: survey.matId,
                      })
                      setTags([
                        ...tags,
                        {tag: newValue[newValue.length - 1].inputValue},
                      ])
                      setSelectedTags([
                        ...selectedTags,
                        {tag: newValue[newValue.length - 1].inputValue},
                      ])
                    } else {
                      setSelectedTags([
                        ...selectedTags,
                        {tag: newValue[newValue.length - 1].tag},
                      ])
                    }
                  }
                }}
                filterOptions={(options, params) => {
                  if (params.inputValue === '') return options
                  const filtered = [
                    ...options.filter(option =>
                      option.tag
                        .toLocaleLowerCase()
                        .includes(params.inputValue.toLocaleLowerCase())
                    ),
                  ]

                  const {inputValue} = params
                  // Suggest the creation of a new value
                  const isExisting = options.some(option =>
                    option.tag
                      .toLocaleLowerCase()
                      .includes(params.inputValue.toLocaleLowerCase())
                  )
                  if (inputValue !== '' && !isExisting) {
                    filtered.push({
                      inputValue: inputValue,
                      tag: `Add "${inputValue}"`,
                    })
                  }

                  return filtered
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderInput={params => <TextField {...params} />}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} mt={3}>
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                {/* <WbOutlineButton
                            CustomOutlineButtonText={'Cancel'}
                            onClick={onClose}
                            ></WbOutlineButton> */}
                <WbButton
                  CustomButtonText={'Add Tag'}
                  onClick={onSave}
                ></WbButton>
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </Modal>
  )
}
